var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ height: "15", viewBox: "0 0 9 15", width: "9", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.954 7.563v-.01c0-.02.005-.045.005-.065s0-.046-.005-.066v-.01c0-.02-.005-.035-.01-.055a.646.646 0 0 0-.181-.326L1.732.186A.663.663 0 0 0 1.263 0a.681.681 0 0 0-.469.186.63.63 0 0 0 0 .907l6.561 6.395L.8 13.882a.63.63 0 0 0 0 .908.66.66 0 0 0 .463.185c.175 0 .34-.065.469-.19l7.031-6.846a.612.612 0 0 0 .18-.321c.006-.02.006-.035.01-.055z", fill: "#353535", fillRule: "evenodd" })
  );
});


// WEBPACK FOOTER //
// ./components/svg/arrows/arrow-right.svg